// extracted by mini-css-extract-plugin
export default {"messageBox":"messageBox_messageBox__CCxkL","correct":"messageBox_correct__iX-Q4","wrong":"messageBox_wrong__TkQmD","clue":"messageBox_clue__h6OaO"};